import Zond from "@assets/images/zondicons_save-disk.svg";
import { Button } from "@material-ui/core";
import { alternatedMaterialUrl } from "@saleor/alternatedMaterial/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";

import MyTypography from "../../../components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "../../../components/Siderbar";
import useAppState from "../../../hooks/useAppState";
import { useAddAltermatedMaterial } from "./EditAlternatedContext";
import { ALT_MATERIAL_TYPE } from "./EditItem";
interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsStyleType>(
  theme => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 16,
      height: 80,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 9
    },
    barRight: {
      display: "flex",
      alignItems: "center"
    },
    btnOrder: {
      width: 180,
      height: 48,
      marginLeft: 20,
      "& button": {
        width: "100%"
      }
    },
    btnDownload: {
      color: theme.palette.info.main
    },
    grayscaleImage: {
      color: "#FFFFFF"
    },
    btnText: {
      color: "white"
    },
    updateTime: {
      color: theme.palette.info.main
    }
  }),
  { name: "BottomBar" }
);

const BottomBar: React.FC<any> = () => {
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });
  const navigate = useNavigator();
  const handleBack = () => {
    navigate(alternatedMaterialUrl);
  };
  const {
    formik,
    handleOpenPopup,
    materialOwnIdError
  } = useAddAltermatedMaterial();

  const disabled = useMemo(
    () =>
      !formik.values.materialOwn ||
      !formik.values.priority.length ||
      formik.values.priority?.find(e => !e.materialOsId) ||
      !formik.values.saleOrganization ||
      !formik.values.type ||
      materialOwnIdError ||
      !formik.values.soldTo ||
      (formik.values.type === ALT_MATERIAL_TYPE.GRADE_GRAM &&
        formik.values.priority?.find(e => !e.dia)),
    [formik.values, materialOwnIdError]
  );

  return (
    <div className={classes.bottomBar}>
      <div>
        <MyTypography variant="caption" />
      </div>
      <div className={classes.barRight}>
        <div className={classes.btnOrder}>
          <Button
            id="cancel"
            onClick={handleBack}
            variant={"outlined"}
            color={"secondary"}
          >
            <MyTypography variant="body1" className={classes.btnDownload}>
              <FormattedMessage defaultMessage={"Cancel"} />
            </MyTypography>
          </Button>
        </div>
        <div className={classes.btnOrder}>
          <Button
            id="addMasterData"
            disabled={disabled}
            onClick={handleOpenPopup}
            variant={"contained"}
            color={"secondary"}
            style={{ width: "240px", height: "50px" }}
            data-testid="addMasterData"
          >
            <img
              src={Zond}
              alt="Save Icon"
              className={classes.grayscaleImage}
              style={{ marginRight: "8px" }}
            />
            <MyTypography variant="button2" className={classes.btnText}>
              <FormattedMessage defaultMessage={"บันทึกข้อมูล Master "} />
            </MyTypography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
